import { render, staticRenderFns } from "./TeamTable.vue?vue&type=template&id=22f24bef&scoped=true&"
import script from "./TeamTable.vue?vue&type=script&lang=js&"
export * from "./TeamTable.vue?vue&type=script&lang=js&"
import style0 from "./TeamTable.vue?vue&type=style&index=0&id=22f24bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f24bef",
  null
  
)

export default component.exports